import React from 'react';

import baitaLogo from '@/assets/images/baita-bank-logo.svg';
import loginIllustration from '@/assets/images/login-illustration.webp';
import { LoginForm } from '@features/authentication/components/LoginForm';

export const LoginPage: React.FC = () => {
  return (
    <div className="flex flex-col lg:flex-row w-full h-screen">
      {/* Left Panel - Branding (Hidden on mobile, visible on lg+) */}
      <div className="hidden lg:flex lg:w-1/2 h-full relative overflow-hidden bg-neutral-50">
        {/* Illustration */}
        <div>
          <img
            src={loginIllustration}
            alt=""
            className="w-full h-full object-contain drop-shadow-2xl"
          />
        </div>
      </div>
      {/* Right Panel - Login Form */}
      <div className="flex items-center justify-center p-6 lg:p-12 lg:w-1/2 h-full bg-neutral-50">
        <div className="w-full">
          {/* Mobile Logo (visible on mobile only) */}
          <div className="lg:hidden text-center mb-8">
            <img src={baitaLogo} alt="Baita Bank" className="h-12 w-auto mx-auto mb-4" />
          </div>

          {/* Login Card */}
          <div>
            <h1 className="text-4xl font-bold text-neutral-900 mb-2 text-center">
              Painel gerencial
            </h1>
            <p className="text-neutral-600 text-base mb-6 text-center">
              Acesse a sua conta abaixo:
            </p>
            <LoginForm />
          </div>
        </div>
      </div>
    </div>
  );
};
